// Category refinement lives in one of two state buckets: a disjunctive
// category_paths refinement behind :plp_multi_select_categories, else the
// hierarchical trail. See docs/search/plp-filters.md
const getSelectedCategoryPaths = (state) => {
  const paths = (state.disjunctiveFacetsRefinements || {}).category_paths || []
  if (paths.length > 0) return paths

  return (state.hierarchicalFacetsRefinements || {})['category_hierarchy.lvl0'] || []
}

// 'Furniture > Storage > Cabinets' -> 'cabinets'; a path that owns no fields -> ''
const getSelectedCategory = (path) => {
  const categories = String(path).split('>')

  for (let i = categories.length - 1; i >= 0; i--) {
    const category = categories[i].toLowerCase().trim()
    if (productTypeSpecificFields()[category]) {
      return category
    }
  }
  return ''
}

const getSelectedCategoryFields = (state) => {
  return getSelectedCategoryPaths(state)
    .map(path => getSelectedCategory(path))
    .filter(Boolean)
    .flatMap(category => productTypeSpecificFields()[category])
    .map(field => field.replace('_id', ''))
}

const productTypeSpecificFields = () => {
  const element = window.product_specific_fields
  return element || {}
}

const allProductTypeSpecificFields = () => {
  return Object.values(productTypeSpecificFields())
    .flat()
    .map(field => field.replace('_id', ''))
}

// Mirrors Search::Facets::FIXED_BOUND_RANGES: no facets are requested for
// these, so an empty value list is normal
const FIXED_BOUND_RANGES = ['width_float', 'height_float', 'depth_float']

export const shouldHide = (attribute, options) => {
  if (FIXED_BOUND_RANGES.includes(attribute)) return false

  if (attribute && options.results.getFacetValues(attribute).length === 0) {
    return true
  }

  // Facets end in _name and the field lists in _id; both compare as door_type
  const fieldName = attribute.replace('_name', '')

  // Product-type-specific filters hide by default; every other filter shows
  if (allProductTypeSpecificFields().includes(fieldName)) {
    return !getSelectedCategoryFields(options.state).includes(fieldName)
  }
  return false
}
